'use strict';

import jquery from 'jquery';

if(!document.querySelector('[data-search="coveo-for-sitecore"]')) {
	window.$ = jquery;
	window.jQuery = jquery;
}

/*
* Import external vendors
 */
require('./modernizr');

/*
* Import global lib
 */
import Cookies from 'js-cookie';
import axios from 'axios';
import matchHeight from 'jquery-match-height';
import { detect } from 'detect-browser';
import 'loadjs';

require('../scripts/vendors/jquery.waypoints.js');

import lity from 'lity';

/*
* Import components
 */
import { getBreakpoint } from './utils/utils';

/*
* set global Var
 */
global.lang = global.lang || $('[lang]').attr('lang');
global.breakpoint = global.breakpoint || getBreakpoint();
global.lity = global.lity || lity;
global.http = global.http || axios;
global.browser = detect();
global.Cookies = global.Cookies || Cookies;
global.isMobileZone = global.isMobileZone || false;
global.youtubePlayer = global.youtubePlayer || '';
global.playResource = global.playResource || false;
global.Velocity = require('velocity-animate');
$.fn.velocity = require('velocity-animate');

global.globalDependenciesAreLoaded = true;